import React, { useEffect, useMemo, useState } from "react";

function defaultPlaceholderDataUri(label = "Smart Farming") {
  const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="800" viewBox="0 0 1200 800">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#1f6b4a" stop-opacity="0.65"/>
      <stop offset="1" stop-color="#e08e45" stop-opacity="0.55"/>
    </linearGradient>
  </defs>
  <rect width="1200" height="800" fill="url(#g)"/>
  <rect x="70" y="70" width="1060" height="660" rx="48" fill="rgba(250,246,237,0.22)" stroke="rgba(250,246,237,0.35)"/>
  <text x="110" y="170" font-family="Georgia, serif" font-size="64" fill="rgba(250,246,237,0.92)">${label}</text>
  <text x="110" y="230" font-family="system-ui, -apple-system, Segoe UI, sans-serif" font-size="22" fill="rgba(250,246,237,0.78)">Image not available — using default placeholder</text>
</svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

export default function SafeImage({
  src,
  alt,
  className,
  fallbackSrc,
  fallbackLabel,
  ...props
}) {
  const placeholder = useMemo(
    () => fallbackSrc || defaultPlaceholderDataUri(fallbackLabel || "Smart Farming"),
    [fallbackLabel, fallbackSrc]
  );
  const [current, setCurrent] = useState(src || placeholder);

  useEffect(() => {
    // When src changes (e.g. slider switching), update displayed image.
    setCurrent(src || placeholder);
  }, [src, placeholder]);

  return (
    <img
      src={current}
      alt={alt || ""}
      className={className}
      onError={() => setCurrent(placeholder)}
      {...props}
    />
  );
}

